import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';
import { OrderByPipe } from '../../../pipes/order-by.pipe';
import { FindContribuenteComponent } from '../find-contribuente/find-contribuente.component';

import { Person } from '../../../models/person';
import { PersonRel } from '../../../models/person-rel';

@Component({
  selector: 'app-contribuente-associati',
  templateUrl: './contribuente-associati.component.html',
  styleUrls: ['./contribuente-associati.component.css']
})
export class ContribuenteAssociatiComponent implements OnInit {
	@Input() data: any = null;
	@Input() writePermission: boolean = false;
	associatiAttuali: boolean = true;
	max_local_id = 0;
	newEditPerson: boolean[] = [];
	qualificheAssociatoSelected: any[] = [];
	editable: boolean[] = [];
	active_tab: any = "attuali";

	qualificheAssociatoAll: any[] = [];
	qualificheAssociatoSync: Subscription;

	idPerson: any = null;
	person: Person;
	anagraficaSync: Subscription;

	associati: PersonRel[] = [];
	associatiSync: Subscription;

	constructor(private dataService: DataService) { }

	ngOnInit() {
		this.person = new Person();
		this.anagraficaSync = this.dataService.getContribuentiService().anagrafica$.subscribe(
			() => {
				if (this.idPerson) {
					this.person = new Person(this.idPerson);
				}
			});
		this.associatiSync = this.dataService.getContribuentiService().associati$.subscribe(
			() => {
				this.dataService.getContribuentiService().getAssociatiByPersonId(this.idPerson, (associati) => {
					this.associati =  associati;
				});
			});
		this.qualificheAssociatoSync = this.dataService.qualificheAssociato$.subscribe(
			qualificheAssociato => {
				this.qualificheAssociatoAll = qualificheAssociato;
			});

		this.resetComponent();
	}

	ngOnChanges(changes: any){
		if (changes.data) {
			let currentData = changes.data.currentValue;
			if(currentData.idPerson && this.data.idPerson > 0){
				this.idPerson = this.data.idPerson;
				this.dataService.getContribuentiService().getAssociatiByPersonId(this.idPerson, (associati) => {
					this.associati =  associati;
				});

				this.dataService.getPersonById(this.idPerson, (person) => {
					if(person){
						this.person = person;
					}else{
						this.person = new Person(this.idPerson);
					}
				});
			}
		}
	}

	resetComponent(){
		console.log("reset component");
		this.max_local_id = 0;
		for (let associato of this.associati){
			if(associato.id > this.max_local_id)
				this.max_local_id = associato.id;
			associato.local_id = String(associato.id) + ':' + String(this.dataService.getComuniService().getComuneId());
			this.editable[associato.local_id] = false;
			this.newEditPerson[associato.local_id] = false;
			this.qualificheAssociatoSelected[associato.local_id] = associato.qualifica_associato_id;
		}
	}

	//	Funzioni richiamate direttamente dall'interfaccia
	aggiungiAssociato(event: any){
		let associato = event.content;
		let associatoDuplicato = this.cerca(associato);
		console.log("associato", associato, associatoDuplicato);
		if(associatoDuplicato){
			this.dataService.openMessage('INSERIMENTO ASSOCIATO','Associato già presente, si prega di modificare quello esistente!');
			console.log("associato duplicato");
		}else{
			let newAssociato = new PersonRel();
			this.max_local_id++;
			newAssociato.local_id = String(this.max_local_id) + ':' + String(this.dataService.getComuniService().getComuneId());
			newAssociato.contribuente = this.idPerson;
			newAssociato.associato = associato.anagrafica_id;
			newAssociato.cognome = associato.cognome;
			newAssociato.nome = associato.nome;
			newAssociato.codice_fiscale = associato.codice_fiscale;
			newAssociato.comune_id = String(this.dataService.getComuniService().getComuneId());
			this.associati.push(newAssociato);
			this.editable[newAssociato.local_id] = true;
			this.newEditPerson[newAssociato.local_id] = true;
		}
		// simila il click sulla tab
		this.selectTab('attuali');
	}

	modificaAssociato(associato: any){
		this.editable[associato.local_id] = true;
	}

	salvaAssociato(associato: any){

		this.editable[associato.local_id] = false;

		associato.qualifica_associato_id = this.qualificheAssociatoSelected[associato.local_id];
		let index = this.qualificheAssociatoAll.findIndex((value:any) => {
			return value.id == associato.qualifica_associato_id;
		});
		if(index !== -1){
			associato.qualifica_associato = this.qualificheAssociatoAll[index].nome;
		}

		if(this.newEditPerson[associato.local_id]){
			this.insert(associato);
		}else{
			this.update(associato);
		}
	}

	scartaModificheAssociato(associato: any){
		if(this.newEditPerson[associato.local_id]){
			this.eliminaAssociato(associato);
		}
		else{
			let rel = this.dataService.getContribuentiService().getAnagraficaRelById(associato.id);
			let index = this.associati.findIndex((value: any) => {
				return value.id == rel.id;
			});
			if(index !== -1){
				this.associati[index].local_id = String(this.associati[index].id) + ':' + String(this.dataService.getComuniService().getComuneId());
				this.associati[index].qualifica_associato_id = rel.qualifica_associato_id;
				this.qualificheAssociatoSelected[rel.id] = rel.qualifica_associato_id;
			}
		}
		this.editable[associato.local_id] = false;
	}

	eliminaAssociato(associato: any){
		let index = this.associati.indexOf(associato);
		if(index !== -1){
			this.associati.splice(index, 1);
			if(!this.newEditPerson[associato.local_id])
				this.delete(associato);
		}
	}

	//	Funzioni di supporto
	cerca(associatoRicercato: Person){
		for(let associato of this.associati){
			if(Number(associato.associato) == associatoRicercato.anagrafica_id)
				return true;
		}
		return false;
	}

	insert(associato: any){
		let value: any;

		Object.keys(associato).map((param) => {
			value = Reflect.get(associato, param);
			if(typeof value === 'string')
				Reflect.set(associato, param, value.trim());
		});

		this.dataService.insert("anagrafica_rel", { anagrafica_id: associato.contribuente, associato: associato.associato, qualifica_associato_id: associato.qualifica_associato_id }, true, (error,res) => {
			if (error) {
				//this.dataService.openMessage('INSERIMENTO FLUSSI','si è verificato un problema');
			}
			if(res){
				console.log("lastID:", res.data.newId);
				associato.id = res.data.newId;
				this.newEditPerson[associato.local_id] = false;
			}
		});
	}

	update(associato: any){
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: associato.id });
		let localSets = {
			anagrafica_id: associato.contribuente,
			associato: associato.associato,
			qualifica_associato_id: associato.qualifica_associato_id
		};

		this.dataService.update("anagrafica_rel", localFilters, localSets, true, (error,res) => {
		});
	}

	delete(associato: any){
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: associato.id });

		this.dataService.delete("anagrafica_rel", localFilters, true, (error,res) => {
			if (error) {
				//this.dataService.openMessage('ELIMINAZIONE ANAGRAFICA','si è verificato un errore');
			}
		});
	}

	checkResults(){
		return this.associati.length > 0;
    }

    checkNoResults(){
		return this.associati.length === 0;
    }

	selectTab(tipo){
		switch(tipo){
			case 'attuali':
				this.associatiAttuali = true;
				break;
			case 'cerca':
				this.associatiAttuali = false;
				break;
			default:

		}
		console.log("select", tipo);
	}

	deselectTab(tipo){
		switch(tipo){
			case 'attuali':
				this.associatiAttuali = false;
				break;
			case 'cerca':
				this.associatiAttuali = true;
				break;
			default:

		}
		console.log("deselect", tipo);
	}

	ngOnDestroy() {
		this.associatiSync.unsubscribe();
		this.anagraficaSync.unsubscribe();
		this.qualificheAssociatoSync.unsubscribe();
	}
}
